import React from 'react'
import { Link } from '@reach/router'
import '../style.css'

const ToolCard = ({ title, link, description }) => {
    return (
        <Link to={link}>
            <div className="tool-card-wrapper">
                <h4>{title}</h4>
                {description ? <p>{description}</p> : <></>}
            </div>
        </Link>
    )
}

export default ToolCard
